import type { HealthInsightScoreBand } from "../../utils/healthInsightScoreBands";
import { cn } from "../../lib/utils";

type Props = {
  bands: HealthInsightScoreBand[];
  variant?: "cards" | "rows";
};

export function HealthInsightScoreBandsList({
  bands,
  variant = "rows",
}: Props) {
  if (variant === "cards") {
    return (
      <div className="space-y-2">
        {bands.map((band) => (
          <div
            key={band.label}
            className={cn(
              "flex items-center gap-3 rounded-xl border px-3 py-2.5",
              band.bg,
              band.border,
            )}
          >
            <div className={cn("h-2.5 w-2.5 shrink-0 rounded-full", band.dot)} />
            <span className={cn("flex-1 text-caption1 font-semibold", band.color)}>
              {band.label}
            </span>
            <span className={cn("text-caption1 font-bold", band.color)}>
              {band.range}
            </span>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {bands.map((band) => (
        <div key={band.label} className="flex items-center justify-between text-callout">
          <div className="flex items-center gap-2">
            <span className={cn("h-2.5 w-2.5 rounded-full", band.dot)} />
            <span className={cn("font-semibold", band.color)}>{band.label}</span>
          </div>
          <span className={cn("font-bold tabular-nums", band.color)}>{band.range}</span>
        </div>
      ))}
    </div>
  );
}
